'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var toCodePoints = exports.toCodePoints = function toCodePoints(str) {
  var codePoints = [];
  var i = 0;
  var length = str.length;

  while (i < length) {
    var value = str.charCodeAt(i++);

    if (value >= 0xd800 && value <= 0xdbff && i < length) {
      var extra = str.charCodeAt(i++);

      if ((extra & 0xfc00) === 0xdc00) {
        codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
      } else {
        codePoints.push(value);
        i--;
      }
    } else {
      codePoints.push(value);
    }
  }

  return codePoints;
};

var fromCodePoint = exports.fromCodePoint = function fromCodePoint() {
  if (String.fromCodePoint) {
    return String.fromCodePoint.apply(String, arguments);
  }

  var length = arguments.length;

  if (!length) {
    return '';
  }

  var codeUnits = [];
  var index = -1;
  var result = '';

  while (++index < length) {
    var codePoint = arguments.length <= index ? undefined : arguments[index];

    if (codePoint <= 0xffff) {
      codeUnits.push(codePoint);
    } else {
      codePoint -= 0x10000;
      codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
    }

    if (index + 1 === length || codeUnits.length > 0x4000) {
      result += String.fromCharCode.apply(String, codeUnits);
      codeUnits.length = 0;
    }
  }

  return result;
};

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'; // Use a lookup table to find the index.

var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);

for (var i = 0; i < chars.length; i++) {
  lookup[chars.charCodeAt(i)] = i;
}

var decode = exports.decode = function decode(base64) {
  var bufferLength = base64.length * 0.75,
      len = base64.length,
      i = void 0,
      p = 0,
      encoded1 = void 0,
      encoded2 = void 0,
      encoded3 = void 0,
      encoded4 = void 0;

  if (base64[base64.length - 1] === '=') {
    bufferLength--;

    if (base64[base64.length - 2] === '=') {
      bufferLength--;
    }
  }

  var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
  var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);

  for (i = 0; i < len; i += 4) {
    encoded1 = lookup[base64.charCodeAt(i)];
    encoded2 = lookup[base64.charCodeAt(i + 1)];
    encoded3 = lookup[base64.charCodeAt(i + 2)];
    encoded4 = lookup[base64.charCodeAt(i + 3)];
    bytes[p++] = encoded1 << 2 | encoded2 >> 4;
    bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
    bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
  }

  return buffer;
};

var polyUint16Array = exports.polyUint16Array = function polyUint16Array(buffer) {
  var length = buffer.length;
  var bytes = [];

  for (var _i = 0; _i < length; _i += 2) {
    bytes.push(buffer[_i + 1] << 8 | buffer[_i]);
  }

  return bytes;
};

var polyUint32Array = exports.polyUint32Array = function polyUint32Array(buffer) {
  var length = buffer.length;
  var bytes = [];

  for (var _i2 = 0; _i2 < length; _i2 += 4) {
    bytes.push(buffer[_i2 + 3] << 24 | buffer[_i2 + 2] << 16 | buffer[_i2 + 1] << 8 | buffer[_i2]);
  }

  return bytes;
};